import { RouteEntry } from "../../../shared/routes";
import { IdentityRoles } from "../../../configure/security/IdentityRoles";
import { SubscriptionAssessmentsList } from "./SubscriptionAssessmentsList";

export const subscriptionAssessmentRoutes: Array<RouteEntry> = [
    { path: '/administration/subscriptions/details/:subscriptionId/assessments', exact: true, component: SubscriptionAssessmentsList, authorize: true, requireRole: IdentityRoles.Administration },
];
